<template>
  <ModalConfirmation
    :showClose="false"
    :isSubmitButtonLoading="isCancellingLesson"
    @close="$emit('close')"
    @confirm="onConfirmCancelLesson"
    :isShowConfirmDeleteMessage="false">
    <div slot="custom_warning">
      <template v-if="!isCanceled">
        <h4>{{ i18n.confirm_cancel_title }}</h4>
        <p class="pad-1 italic pad-0-top">{{ i18n.confirm_cancel_text }}</p>
      </template>
      <template v-else>
        <h4>{{ i18n.confirm_uncancel_title }}</h4>
        <p class="pad-1 italic">{{ i18n.confirm_uncancel_text }}</p>
      </template>
    </div>
    <p slot="confirmText">{{ !isCanceled ? i18n.cancel_event : i18n.uncancel_event }}</p>
  </ModalConfirmation>
</template>

<script>
import ModalConfirmation from '../Modals/ModalConfirmation.vue'
import docendo from '../../docendo'

const I18N = {
  da: {
    cancel_event: 'Aflys timen',
    uncancel_event: 'Fortryd aflysning',
    confirm_cancel_title: 'Er du sikker på, at du vil aflyse timen?',
    confirm_cancel_text: 'Timen bliver ikke slettet, men vil blive markeret som aflyst med overstregede tekster.',
    confirm_uncancel_title: 'Er du sikker på, at du vil fortryde aflysningen?',
    confirm_uncancel_text: 'Timen vil blive gendannet, og de overstregede tekster fjernes.'
  },
  no: {
    cancel_event: 'Avlys timen',
    uncancel_event: 'Angre avlysning',
    confirm_cancel_title: 'Er du sikker på at du vil avlyse timen?',
    confirm_cancel_text: 'Timen blir ikke slettet, men vil bli markert som avlyst med gjennomstreket tekst.',
    confirm_uncancel_title: 'Er du sikker på at du vil angre avlysningen?',
    confirm_uncancel_text: 'Timen vil bli gjenopprettet, og den gjennomstrekede teksten fjernes.'
  },
  en: {
    cancel_event: 'Cancel lesson',
    uncancel_event: 'Undo cancellation',
    confirm_cancel_title: 'Are you sure you want to cancel the lesson?',
    confirm_cancel_text: 'The lesson will not be deleted but will be marked as canceled with strikethrough text.',
    confirm_uncancel_title: 'Are you sure you want to undo the cancellation?',
    confirm_uncancel_text: 'The lesson will be restored, and the strikethrough text will be removed.'
  }
}

export default {
  components: { ModalConfirmation },
  props: {
    event: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isCancellingLesson: false
    }
  },
  computed: {
    isCanceled () {
      return this.event.canceled
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N.en // Fallback til engelsk, hvis sproget ikke er defineret
    }
  },
  methods: {
    onConfirmCancelLesson () {
      this.handleConfirmCancelLesson()
    },
    handleConfirmCancelLesson () {
      this.isCancellingLesson = true
      const updatedLesson = {
        school_id: this.event.school_id,
        updates: [{ event_id: this.event.event_id, canceled: !this.isCanceled }]
      }
      docendo.updateEvents(
        updatedLesson.school_id,
        updatedLesson.updates,
        success => {
          this.isCancellingLesson = false
          this.$emit('updated')
        },
        failure => {
          console.log('failed')
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// DModalCancelLesson.vue?a1b3941c